import React, { useEffect, useState } from "react";
import { useDataProvider } from "../../api/DataProvider";
import "../../styles/devices/mob_SignDialog.css";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import NativeSelect from "@mui/material/NativeSelect";
import Paper from "@mui/material/Paper";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

export default function DialogContentSelectManual(props) {
  const { handleClickManualSelectionLemmaManual } = props;
  const { getListAllLemmasAvailable, getListNameDefinitions, sortArrDictsByField } = useDataProvider();

  const [arrLemmasAll, setArrLemmasAll] = useState([]);

  useEffect(() => {
    const arr_lemmas_all = getListAllLemmasAvailable();
    const arrGetListNameDefinitions = sortArrDictsByField(getListNameDefinitions(arr_lemmas_all), "name");
    setArrLemmasAll(arrGetListNameDefinitions);
  }, []);

  return (
    <div className="sig_SignDialog_TitleContainer">
      {arrLemmasAll[0] !== undefined ? (
        <>
          <Paper className="sig_SignModal_PaperContent">
            <div className="sig_SignModal_PaperTitle sig_SignModal_PaperTitle_Select_Manual">
              <span>¿No hemos acertado? </span>
              <SentimentVeryDissatisfiedIcon fontSize="small" />
            </div>
            <hr></hr>
            {/* <div className="sig_SignModal_PaperBody">Sentimos no haber acertado el signo. Para mejorar su colaboración es fundamental. Le agradecemos que nos reportase que palabra ha signado dentro del siguiente listado y pulse el boton de enviar. Muchas gracias por su colaboración.</div> */}
            <div className="sig_SignModal_PaperBody">
              Sentimos no haber acertado el signo. <br></br>Por favor, ayúdanos a mejorar indicándonos qué signo has hecho en el siguiente listado.
            </div>
          </Paper>
          <br />

          <FormControl fullWidth>
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Pulsa aquí para mostrar el listado de palabras
            </InputLabel>
            <NativeSelect
              onChange={handleClickManualSelectionLemmaManual}
              defaultValue={""}
              inputProps={{
                name: "age",
                id: "uncontrolled-native",
              }}
            >
              <option aria-label="None" value="" />
              {arrLemmasAll.map((item, idx) => {
                return (
                  <option key={idx} value={item["_id"]}>
                    {item["name"]}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
